import { Instance } from "mobx-state-tree";
import { EmailTemplatesStore } from "./EmailTemplatesStore";
import { useRootStore } from "../../root/store/RootStore";
import { EmailTemplateDetailsStore } from "./EmailTemplateDetailsStore";
import { CreateEmailTemplateStore } from "./CreateEmailTemplateStore";
import { UpdateEmailTemplateStore } from "./UpdateEmailTemplateStore";
import { DeleteEmailTemplateStore } from "./DeleteEmailTemplateStore";
import { CustomPlaceholdersStore } from "./CustomPlaceholdersStore";

export const useEmailTemplatesStore = (): Instance<
  typeof EmailTemplatesStore
> => useRootStore().emailTemplatesStore;

export const useEmailTemplateDetailsStore = (): Instance<
  typeof EmailTemplateDetailsStore
> => useRootStore().emailTemplateDetailsStore;

export const useCreateEmailTemplateStore = (): Instance<
  typeof CreateEmailTemplateStore
> => useEmailTemplateDetailsStore().createEmailTemplateStore;

export const useUpdateEmailTemplateStore = (): Instance<
  typeof UpdateEmailTemplateStore
> => useEmailTemplateDetailsStore().updateEmailTemplateStore;

export const useDeleteEmailTemplateStore = (): Instance<
  typeof DeleteEmailTemplateStore
> => useEmailTemplateDetailsStore().deleteEmailTemplateStore;

export const useCustomPlaceholdersStore = (): Instance<
  typeof CustomPlaceholdersStore
> => useRootStore().customPlaceholdersStore;
